'use strict';

function Contact (object) {
  this.contactName = object.get('contactName') || null;

  const phones = object.get('contactPhones') || [];
  this.contactPhones = phones.count ? phones.map(c => c.get('formatted')).toJS() : null;

  this.xmlPhones = [object.get('contactsFromXmlFeed')] || null;
}

Contact.prototype.getName = function () {
  return this.contactName;
};

Contact.prototype.getPhones = function () {
  return this.contactPhones || this.xmlPhones || [];
};

export default Contact;



// WEBPACK FOOTER //
// ./src/classes/common/contact.js